import Vue from 'vue'
import select from 'dom-select'
import on from 'dom-event'
import { refreshYotpoWidgets } from 'lib/util'

Vue.component('yotpo-bottomline', {
  props: [
    'id',
    'reviewsCount',
    'reviewLink',
    'align',
    'title',
    'hideReviewText'
  ],
  data () {
    return {
      link: '',
      reviewTitle: 'This product has a rating of 5 stars out of 5'
    }
  },
  mounted () {
    refreshYotpoWidgets()

    const observer = new window.MutationObserver((mutations) => {
      if (mutations.length) {
        const starsEl = select('.yotpo-stars', this.$refs.starReviews)
        const starClickable = select('.yotpo-bottomline.pull-left.star-clickable', this.$el)
        const reviewTitle = select('.yotpo-stars .sr-only', this.$refs.starReviews)
        const reviewLink = select('.text-m', this.$refs.starReviews)
        if (starsEl) {
          starsEl.setAttribute('aria-hidden', 'true')
        }
        if (reviewTitle && reviewTitle.innerText && reviewLink && reviewLink.textContent) {
          this.reviewTitle = 'This product has ' + reviewTitle.innerText + ' out of 5.0 with ' + reviewLink.textContent
        }
        if (starClickable) {
          starClickable.removeAttribute('tabindex')
          starClickable.setAttribute('aria-hidden', 'true')
        }
        if (reviewLink && this.hideReviewText === true) {
          const reviewsCount = parseFloat(reviewLink.textContent)
          if (!isNaN(reviewsCount)) {
            reviewLink.textContent = `(${reviewsCount})`
          }
        }
        const reviewNumbers = select('.yotpo-bottomline.pull-left.star-clickable a', this.$el)
        if (reviewNumbers) {
          reviewNumbers.outerHTML = '<p class="text-m underline" aria-hidden="true">' + reviewNumbers.innerHTML + '</p>'
        }
      }
    })

    if (this.$refs.starReviews) {
      observer.observe(this.$refs.starReviews, {
        childList: true
      })
    }

    const reviewAnchor = select('form .js-review-anchor')

    if (reviewAnchor) {
      on(reviewAnchor, 'click', (e) => {
        e.preventDefault()
        const reviewWrapper = select('.free-text-search-input')
        reviewWrapper.focus()
      })
    }
  },
  template: `
    <div class="yotpo-bottomline-wrap js-reviews" :class="{ 'align-left': align === 'left' }">
      <a :href="reviewLink ? reviewLink : '#'" class="yotpo-bottomline__review-link js-review-anchor" :aria-label="reviewTitle">
        <div v-if="reviewsCount && reviewsCount >= 1" class="yotpo bottomLine" :data-product-id="id" ref="starReviews"></div>
        <div class="yotpo bottomLine" v-else :data-product-id="id" ref="starReviews">
          <div class="yotpo-bottomline star-clickable" aria-hidden="true">
            <span class="yotpo-stars" aria-hidden="true">
              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
            </span>
            <div class="yotpo-clr"></div>
          </div>
        </div>
      </a>
    </div>
  `
})
